export default __webpack_public_path__ + "static/media/e-sus.8e1875a8.svg";